var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: "Acciones",
          expression: "'Acciones'"
        }
      ]
    },
    [
      _c(
        "vs-dropdown",
        { attrs: { "vs-custom-content": "", "vs-trigger-click": "" } },
        [
          _c(
            "a",
            { staticClass: "a-icon", attrs: { "href.prevent": "" } },
            [
              _c("vs-icon", {
                attrs: {
                  icon: "more_vertical",
                  size: "medium",
                  bg: "#E4E4E4",
                  round: "",
                  color: "gray"
                }
              })
            ],
            1
          ),
          _c(
            "vs-dropdown-menu",
            _vm._l(_vm.acciones, function(accion) {
              return _c(_vm.cargarComponenteAccion(accion), {
                key: accion,
                tag: "component",
                attrs: {
                  "handle-list": _vm.handleList,
                  accion: accion,
                  documento: _vm.documento
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.getTitulo,
            "no-close-on-backdrop": "",
            centered: "",
            "hide-footer": ""
          },
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.mostrarModal = false
            }
          },
          model: {
            value: _vm.mostrarModal,
            callback: function($$v) {
              _vm.mostrarModal = $$v
            },
            expression: "mostrarModal"
          }
        },
        [
          _vm.mostrarModal
            ? _c(_vm.getCompomente, { tag: "component" })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.getTitulo,
            "no-close-on-backdrop": "",
            centered: "",
            "hide-footer": "",
            "content-class": "fullscreen",
            size: "xl"
          },
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.mostrarModalFull = false
            }
          },
          model: {
            value: _vm.mostrarModalFull,
            callback: function($$v) {
              _vm.mostrarModalFull = $$v
            },
            expression: "mostrarModalFull"
          }
        },
        [
          _vm.mostrarModalFull
            ? _c(_vm.getCompomente, { tag: "component" })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }